module.exports = __webpack_public_path__ + "img/college-course-pic-2.e54c093.jpg";